import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';


import { ABTestData } from '../ReactProtos/Proto/dcei_wildsky_abtest_proto';
import { EnergySystemData } from '../ReactProtos/Proto/dcei_wildsky_energy_system_proto';
import { MineData } from '../ReactProtos/Proto/dcei_wildsky_mine_proto';
import { CampaignData,CampaignRewardData } from '../ReactProtos/Proto/dcei_wildsky_campaign_proto';
import { CardDefinitions } from '../ReactProtos/Proto/dcei_wildsky_card_proto';
import { CardSkinDefinitions } from '../ReactProtos/Proto/dcei_wildsky_card_proto';
import { SkillRechargeConfig } from '../ReactProtos/Proto/dcei_wildsky_card_proto';
import { CheckGitlabAccess } from './CheckGitlabAccess';
import { Dungeons } from '../ReactProtos/Proto/dcei_wildsky_dungeon_proto';
import { GachaConfig } from '../ReactProtos/Proto/dcei_wildsky_gacha_proto';
import { EditorBase } from './EditorBase';
import { InAppPurchaseData } from '../ReactProtos/Proto/dcei_wildsky_in_app_purchase_proto';
import { InventoryData } from '../ReactProtos/Proto/dcei_wildsky_inventory_proto';
import { RandomRewardChestData } from '../ReactProtos/Proto/dcei_wildsky_random_reward_chest_proto';
import { LoginRewardData } from '../ReactProtos/Proto/dcei_wildsky_login_reward_proto';
import { MailDefinition } from '../ReactProtos/Proto/dcei_wildsky_mails_proto';
import { MarketData } from '../ReactProtos/Proto/dcei_wildsky_market_proto';
import { QuestAndAchievementData, DailyQuestDefinition } from '../ReactProtos/Proto/dcei_wildsky_quest_and_achievement_proto';
import { SaveFile } from '../ReactProtos/Proto/dcei_wildsky_save_proto';
import { SubscriptionData } from '../ReactProtos/Proto/dcei_wildsky_subscription_proto';
import { MapEventData, MapEvent } from '../ReactProtos/Proto/dcei_wildsky_map_event_proto';
import { EventQuestData } from '../ReactProtos/Proto/dcei_wildsky_event_quest_proto';
import { StoryEventData, StoryEvent } from '../ReactProtos/Proto/dcei_wildsky_story_event_proto'
import { MapData } from '../ReactProtos/Proto/dcei_wildsky_map_proto';
import { FriendSystemData } from '../ReactProtos/Proto/dcei_wildsky_friend_system_proto';
import { RewardPatternData } from '../ReactProtos/Proto/dcei_wildsky_reward_proto';
import { PageNavigationEntry } from '../ReactProtos/Proto/dcei_wildsky_common_proto';
import { LazySelect } from '../ReactProtos/CellSelect';
import { HelpNavigationData } from '../ReactProtos/Proto/dcei_wildsky_help_navigation_proto';
import { CardSkinData } from '../ReactProtos/Proto/dcei_wildsky_card_proto';
import { ShipUpgradeDefinitions } from '../ReactProtos/Proto/dcei_wildsky_ship_upgrade_proto';
import { DailyTrialData } from '../ReactProtos/Proto/dcei_wildsky_daily_trial_proto';
import { PromotionBundleConfigs, PromotionBundleConfig } from '../ReactProtos/Proto/dcei_wildsky_promotion_bundle_proto';
import { Compendium, GeneralUIContent} from '../ReactProtos/Proto/dcei_wildsky_ui_content_proto';

const etDungeonIndexTable = [
    { value: "0", label: '0_None' },
    { value: "1", label: '1_Water' },
    { value: "2", label: '2_Fire' },
    { value: "3", label: '3_Nature' },
    { value: "4", label: '4_Might' },
    { value: "5", label: '5_Dark' },
    { value: "6", label: '6_Light' }
];

const mineDungeonFloorTable = [
    { value: "mine_dungeon_floor_gold", label: 'mine_dungeon_floor_gold' },
    { value: "mine_dungeon_floor_hero", label: 'mine_dungeon_floor_hero' },
    { value: "mine_dungeon_floor_spell", label: 'mine_dungeon_floor_spell' },
    { value: "mine_dungeon_floor_tower", label: 'mine_dungeon_floor_tower' }
];

class TempleIndexEditor extends React.PureComponent {
    onChange = v => {
        this.props.onChange(v.value);
    }
    render() {
        const entry = etDungeonIndexTable.find(i => (i.value | 0) === this.props.value);
        const label = entry && entry.label;
        return (
            <LazySelect value={{ value: this.props.value, label }}
                options={etDungeonIndexTable} onChange={this.onChange} />
        );
    }
}

class MineFloorImageEditor extends React.PureComponent {
    onChange = v => {
        this.props.onChange(v.value);
    }
    render() {
        const entry = mineDungeonFloorTable.find(i => (i.value | 0) === this.props.value);
        const label = entry && entry.label;
        return (
            <LazySelect value={{ value: this.props.value, label }}
                options={mineDungeonFloorTable} onChange={this.onChange} />
        );
    }
}

class DateTimeEditor extends React.PureComponent {
    onChange = date => {
        if (typeof (date) == "object") {
            this.props.onChange(Math.floor(date.toDate().getTime() / 1000 + 7 *3600));
        }
    }

    render() {
        return (
            <div>
                <Datetime utc = {true} value={new Date((this.props.value -7 *3600) * 1000)} onChange={this.onChange} />
            </div>
        );
    }
}

PageNavigationEntry.PortalPage.descriptor.fields.find(f => f.name === 'dungeonIndex').customEditor = TempleIndexEditor;
MineData.Floor.descriptor.fields.find(f => f.name === 'displayImage').customEditor = MineFloorImageEditor;

InAppPurchaseData.DealGroup.BundleGroup.descriptor.fields.find(f => f.name === "startTime").customEditor = DateTimeEditor;
InAppPurchaseData.DealGroup.BundleGroup.descriptor.fields.find(f => f.name === "endTime").customEditor = DateTimeEditor;

MapEvent.CalendarTimeTrigger.descriptor.fields.find(f => f.name === "eventStartTime").customEditor = DateTimeEditor;
MapEvent.GuildBossConfig.descriptor.fields.find(f => f.name === "startTime").customEditor = DateTimeEditor;


PromotionBundleConfig.Filter.DateFilter.descriptor.fields.find(f => f.name === "startTime").customEditor = DateTimeEditor;
PromotionBundleConfig.Filter.DateFilter.descriptor.fields.find(f => f.name === "endTime").customEditor = DateTimeEditor;


export class EditorGroup extends React.PureComponent {
    storageKey = "EditorGroup.Selected";
    components = [
        {
            name: "Campaign",
            file: "Campaign.json",
            component: (props) => <EditorBase {...props} name="Campaign Editor" proto={CampaignData} file="Campaign.json" />,
            menu: {
                title: 'Worlds',
                /**
                 * @param {CampaignData} data
                 */
                getItems(data) {
                    return data.worlds.map((world, index) => ({
                        label: world.path || '<noname>',
                        dispatchPath: ['worlds', index],
                    }));
                },
            },
        },
        {
            name: "CardDefinitions",
            file: "Card/CardDefinitions.json",
            component: (props) => <EditorBase {...props} name="CardDefinitions Editor" proto={CardDefinitions} file="Card/CardDefinitions.json" />,
            menu: {
                title: 'Cards',
                /**
                 * @param {CardDefinitions} data
                 */
                getItems(data) {
                    const cardTypeMap = { [11]: "Hero", [12]: "Tower", [13]: "Spell" };
                    return data.cardDefinitions.map((card, index) => ({
                        label: (cardTypeMap[card.cardTypeCase] || '<unknown>') + ' - ' + (card.name || '<noname>'),
                        dispatchPath: ['cardDefinitions', index],
                        sorting: card.cardTypeCase,
                    })).sort((a, b) => a.sorting - b.sorting);
                },
            },
        },
        {
            name: "ShipUpgradeDefinitions",
            file: "ShipUpgradeDefinitions.json",
            component: (props) => <EditorBase {...props} name="ShipUpgradeDefinitions Editor" proto={ShipUpgradeDefinitions} file="ShipUpgradeDefinitions.json" />,
            menu: {
                title: 'ShipUpgradeDefnitions',
                /**
                 * @param {ShipUpgradeDefinitions} data
                 */

                getItems(data) {
                    let result = [];
                    result = result.concat(data.shipTalentDefinitions.map((talent, index) => ({
                        label: (talent.shipTierRequirement.toString() || '0') + ' - ' + (talent.name || '<noname>'),
                        dispatchPath: ['shipTalentDefinitions', index],
                        sorting: talent.shipTierRequirement,
                    })).sort((a, b) => a.sorting - b.sorting));

                    result = result.concat(data.shipGoldTierSettings.map((tier, index) => ({
                        label: "GoldTier" + (tier.tier || 0).toString(),
                        dispatchPath: ['shipGoldTierSettings', index],
                        sorting: tier.tier || 0,
                    })).sort((a, b) => a.sorting - b.sorting));

                    result = result.concat(data.shipSilverTierSettings.map((tier, index) => ({
                        label: "SilverTier" + (tier.tier || 0).toString(),
                        dispatchPath: ['shipSilverTierSettings', index],
                        sorting: tier.tier || 0,
                    })).sort((a, b) => a.sorting - b.sorting));

                    return result;
                },
            },
        },
        {
            name: "CardSkinDefinitions",
            file: "Card/CardSkinDefinitions.json",
            component: (props) => <EditorBase {...props} name="CardSkinDefinitions Editor" proto={CardSkinDefinitions} file="Card/CardSkinDefinitions.json" />,
            menu: {
                title: 'Cards',
                /**
                 * @param {CardSkinDefinitions} data
                 */
                getItems(data) {
                    const cardTypeMap = { [11]: "Hero", [12]: "Tower" };
                    return data.cardSkinDefinitions.map((card, index) => ({
                        label: (cardTypeMap[card.cardTypeCase] || '<unknown>') + ' - ' + (card.name || '<noname>'),
                        dispatchPath: ['cardSkinDefinitions', index],
                        sorting: card.cardTypeCase,
                    })).sort((a, b) => a.sorting - b.sorting);
                },
            },
        },
        {
            name: "CardSkinData",
            file: "Card/CardSkinData.json",
            component: (props) => <EditorBase {...props} name="CardSkinData Editor" proto={CardSkinData} file="Card/CardSkinData.json" />,
        },
        {
            name: "DefaultSave",
            file: "DefaultSave.json",
            component: (props) => <EditorBase {...props} name="DefaultSave Editor" proto={SaveFile} file="DefaultSave.json" />,
        },
        {
            name: "Dungeons",
            file: "Dungeons.json",
            component: (props) => <EditorBase {...props} name="Dungeons Editor" proto={Dungeons} file="Dungeons.json" />,
            menu: {
                title: 'Dungeons',
                /**
                 * @param {Dungeons} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.elementalTrial.dungeons.map((d, i) => ({
                        label: 'ET - ' + (d.displayName.split('/')[2] || '<unknown>'),
                        dispatchPath: ['elementalTrial', 'dungeons', i],
                    })));
                    result = result.concat(data.rewardPatterns.rewardPatterns.map((d, i) => ({
                        label: 'Reward - ' + d.patternName,
                        dispatchPath: ['rewardPatterns', 'rewardPatterns', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "GachaData",
            repo: 'serverdata',
            file: "GachaData.json",
            component: (props) => <EditorBase {...props} name="GachaData Editor" proto={GachaConfig} file="GachaData.json" />,
            menu: {
                title: 'GachaData',
                /**
                 * @param {GachaConfig} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.gachaLevelGroups.map((d, i) => ({
                        label: 'Regular - ' + d.key,
                        dispatchPath: ['gachaLevelGroups', i],
                    })));
                    result = result.concat(data.promotionalGachaGroups.map((d, i) => ({
                        label: 'Promotional - ' + d.key,
                        dispatchPath: ['promotionalGachaGroups', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "CampaignRewards",
            repo: 'serverdata',
            file: "CampaignRewards.json",
            component: (props) => <EditorBase {...props} name="Campaign Rewards Editor" proto={CampaignRewardData} file="CampaignRewards.json" />,
            menu: {
                title: 'RewardsData',
                /**
                 * @param {CampaignRewardData} data
                 */
                getItems(data) {
                    return data.campaignRewards.map((rewards, index) => ({
                        label: rewards.key || '<noname>',
                        dispatchPath: ['campaignRewards', index],
                    }));
                },
            },
        },
        {
            name: "InAppPurchaseData",
            repo: 'serverdata',
            file: "InAppPurchaseData.json",
            component: (props) => <EditorBase {...props} name="InAppPurchaseData Editor" proto={InAppPurchaseData} file="InAppPurchaseData.json" />,
            menu: {
                title: 'InAppPurchaseData',
                /**
                 * @param {InAppPurchaseData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.products.map((d, i) => ({
                        label: 'Product - ' + d.id,
                        dispatchPath: ['products', i],
                    })));
                    result = result.concat(data.limitedBundles.map((d, i) => ({
                        label: 'LimitedBundle - ' + d.productId,
                        dispatchPath: ['limitedBundles', i],
                    })));
                    result = result.concat(data.subscriptions.map((d, i) => ({
                        label: 'Subscription - ' + d.productId,
                        dispatchPath: ['subscriptions', i],
                    })));
                    result = result.concat(data.tabs.map((d, i) => ({
                        label: 'Tab - ' + d.key,
                        dispatchPath: ['tabs', i],
                    })));
                    result = result.concat(data.bundleDefinitions.map((d, i) => ({
                        label: 'Bundle Definitions - ' + d.productId,
                        dispatchPath: ['bundleDefinitions', i],
                    })));
                    result = result.concat(data.dealGroups.map((d, i) => ({
                        label: 'Deal Bundles - ' + d.groupId,
                        dispatchPath: ['dealGroups', i],
                    })));
                    result = result.concat(data.campaignSaleBundles.map((d, i) => ({
                        label: 'Campaign Bundles - ' + d.productId,
                        dispatchPath: ['campaignSaleBundles', i],
                    })));
                    result = result.concat(data.dailyTrialBundles.map((d, i) => ({
                        label: 'Daily Trial Bundles - ' + d.productId,
                        dispatchPath: ['dailyTrialBundles', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "InventoryData",
            file: "InventoryData.json",
            component: (props) => <EditorBase {...props} name="InventoryData Editor" proto={InventoryData} file="InventoryData.json" />,
            menu: {
                title: 'InventoryData',
                /**
                 * @param {InventoryData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.Items.map((d, i) => ({
                        label: d.key,
                        dispatchPath: ['Items', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "RandomRewardChestData",
            file: "RandomRewardChestData.json",
            component: (props) => <EditorBase {...props} name="RandomRewardChestData Editor" proto={RandomRewardChestData} file="RandomRewardChestData.json" />,
            menu: {
                title: 'RandomRewardChestData',
                /**
                 * @param {RandomRewardChestData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.chests.map((d, i) => ({
                        label: d.key,
                        dispatchPath: ['chests', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "HelpNavigationData",
            file: "HelpNavigationData.json",
            component: (props) => <EditorBase {...props} name="HelpNavigationData Editor" proto={HelpNavigationData} file="HelpNavigationData.json" />,
            menu: {
                title: 'HelpNavigationData',
                /**
                 * @param {HelpNavigationData} data
                 */
                getItems(data) {
                    return [];
                },
            },
        },
        {
            name: "LoginRewardData",
            file: "LoginRewardData.json",
            component: (props) => <EditorBase {...props} name="LoginRewardData Editor" proto={LoginRewardData} file="LoginRewardData.json" />,
        },
        {
            name: "MailData",
            file: "MailData.json",
            component: (props) => <EditorBase {...props} name="MailData Editor" proto={MailDefinition} file="MailData.json" />,
            menu: {
                title: 'MailData',
                /**
                 * @param {MailDefinition} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.mailGroups.map((d, i) => ({
                        label: d.key,
                        dispatchPath: ['mailGroups', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "MarketData",
            repo: 'serverdata',
            file: "MarketData.json",
            component: (props) => <EditorBase {...props} name="MarketData Editor" proto={MarketData} file="MarketData.json" />,
            menu: {
                title: 'MarketData',
                /**
                 * @param {MarketData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(...data.tabs.map((tab, tabIndex) => {
                        let groups = [];
                        groups.push({
                            label: tab.key,
                            dispatchPath: ['tabs', tabIndex],
                        });
                        /**
                         * @param {MarketData.SlotGroup} slot
                         */
                        function formatSlot(slot) {
                            return `Level ${slot.filter.playerLevel.min} - ${slot.filter.playerLevel.max}`;
                        }
                        groups = groups.concat(tab.slotGroup.map((slot, slotIndex) => ({
                            label: tab.key + ' - ' + formatSlot(slot),
                            dispatchPath: ['tabs', tabIndex, 'slotGroup', slotIndex],
                        })));
                        return groups;
                    }));
                    return result;
                },
            },
        },
        {
            name: "QuestAndAchievementData",
            file: "QuestAndAchievementData.json",
            component: (props) => <EditorBase {...props} name="QuestAndAchievementData Editor" proto={QuestAndAchievementData} file="QuestAndAchievementData.json" />,
            menu: {
                title: 'QuestAndAchievementData',
                /**
                 * @param {QuestAndAchievementData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.questData.dailyQuestList.map((d, i) => ({
                        label: 'quest - ' + d.key,
                        dispatchPath: ['questData', 'dailyQuestList', i],
                    })));
                    result = result.concat(data.timedQuestData.questDays.map((d, i) => ({
                        label: 'npq - Day ' + (i + 1),
                        dispatchPath: ['timedQuestData', 'questDays', i],
                    })));
                    result = result.concat(data.achievementData.achievementList.map((d, i) => ({
                        label: 'achievement - ' + d.key,
                        dispatchPath: ['achievementData', 'achievementList', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "SubscriptionData",
            file: "SubscriptionData.json",
            component: (props) => <EditorBase {...props} name="SubscriptionData Editor" proto={SubscriptionData} file="SubscriptionData.json" />,
        },
        {
            name: "MapEventData",
            repo: "serverdata",
            file: "MapEventData.json",
            component: (props) => <EditorBase {...props} name="MapEventData Editor" proto={MapEventData} file="MapEventData.json" />,
            menu: {
                title: 'MapEventData',
                /**
                 * @param {MapEventData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.mapEvents.map((d, i) => ({
                        label: d.key,
                        dispatchPath: ['mapEvents', i],
                    })));
                    result = result.concat(data.levelPrefixes.map((d, i) => ({
                        label: 'Prefix - ' + d.key,
                        dispatchPath: ['levelPrefixes', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "EventQuestData",
            repo: "serverdata",
            file: "EventQuestData.json",
            component: (props) => <EditorBase {...props} name="EventQuestData Editor" proto={EventQuestData} file="EventQuestData.json" />,
            menu: {
                title: 'EventQuestData',
                /**
                 * @param {EventQuestData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.eventQuests.map((d, i) => ({
                        label: d.key,
                        dispatchPath: ['eventQuests', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "StoryEventData",
            file: "StoryEventData.json",
            component: (props) => <EditorBase {...props} name="StoryEventData Editor" proto={StoryEventData} file="StoryEventData.json" />,
            menu: {
                title: 'StoryEventData',
                /**
                 * @param {StoryEventData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.storyEvents.map((d, i) => ({
                        label: d.key,
                        dispatchPath: ['storyEvents', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "CompendiumData",
            file: "CompendiumData.json",
            component: (props) => <EditorBase {...props} name="Compendium Data Editor" proto={Compendium} file="CompendiumData.json" />,
            menu: {
                title: 'Tabs',
                /**
                 * @param {Compendium} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.tabs.map((d, i) => ({
                        label: d.key,
                        dispatchPath: ['tabs', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "MapData",
            file: "Map.json",
            component: (props) => <EditorBase {...props} name="MapData Editor" proto={MapData} file="Map.json" />,
            menu: {
                title: 'MapData',
                /**
                 * @param {MapData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.maps.map((d, i) => ({
                        label: d.key,
                        dispatchPath: ['maps', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "FriendSystemData",
            repo: "serverdata",
            file: "FriendSystem.json",
            component: (props) => <EditorBase {...props} name="Friend System Editor" proto={FriendSystemData} file="FriendSystem.json" />,
        },
        {
            name: "RewardPatternData",
            repo: "serverdata",
            file: "RewardPattern.json",
            component: (props) => <EditorBase {...props} name="Reward Pattern Editor" proto={RewardPatternData} file="RewardPattern.json" />,
            menu: {
                title: 'Reward Pattern',
                /**
                 * @param {RewardPatternData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat(data.rewardPatterns.map((d, i) => ({
                        label: d.patternName,
                        dispatchPath: ['rewardPatterns', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "ABTestData",
            file: "ABTest.json",
            component: (props) => <EditorBase {...props} name="ABTest Editor" proto={ABTestData} file="ABTest.json" />,
        },
        {
            name: "EnergySystemData",
            file: "Energy.json",
            component: (props) => <EditorBase {...props} name="Energy System Editor" proto={EnergySystemData} file="Energy.json" />,
        },
        {
            name: "SkillRechargeConfig",
            repo: "serverdata",
            file: "SkillRechargeConfig.json",
            component: (props) => <EditorBase {...props} name="Skill Point Recharge Editor" proto={SkillRechargeConfig} file="SkillRechargeConfig.json" />,
        },
        {
            name: "MineData",
            file: "Mines.json",
            component: (props) => <EditorBase {...props} name="Mine Editor" proto={MineData} file="Mines.json" />,
            menu: {
                title: 'MineData',
                /**
                 * @param {MineData} data
                 */
                getItems(data) {
                    let result = [];
                    result = result.concat({
                        label: 'Key Config',
                        dispatchPath: ['keyConfig'],
                    });
                    result = result.concat({
                        label: 'Fast Forward Config',
                        dispatchPath: ['fastClaimConfig'],
                    });
                    result = result.concat(data.floors.map((d, i) => ({
                        label: '[' + i + '] Floor: ' + (i + 1),
                        dispatchPath: ['floors', i],
                    })));
                    result = result.concat(data.rewardPatterns.map((d, i) => ({
                        label: 'Reward Pattern: ' + d.patternName,
                        dispatchPath: ['rewardPatterns', i],
                    })));
                    return result;
                },
            },
        },
        {
            name: "DailyTrialData",
            repo: "serverdata",
            file: "DailyTrialData.json",
            component: (props) => <EditorBase {...props} name="Daily Trial Data Editor" proto={DailyTrialData} file="DailyTrialData.json" />,
        },

        {
            name: "PromotionBundleConfigs",
            repo: "serverdata",
            file: "PromotionBundleConfigs.json",
            component: (props) => <EditorBase {...props} name="Promotion Bundle Configs Editor" proto={PromotionBundleConfigs} file="PromotionBundleConfigs.json" />,
        },
    ].sort((a, b) => a.name.localeCompare(b.name));

    constructor(props) {
        super(props);

        const selected = window.localStorage.getItem(this.storageKey);
        if (selected) {
            this.state = {
                selected: selected,
                selecting: false,
            };
        } else {
            this.state = {
                selected: 'Campaign',
                selecting: true,
            };
        }
    }

    componentDidUpdate() {
        window.localStorage.setItem(this.storageKey, this.state.selected);
    }

    onClick = name => () => {
        this.setState({ selected: name, selecting: false });
    }

    showSelectModal = () => {
        this.setState({ selecting: true });
    }

    hideSelectModal = () => {
        this.setState({ selecting: false });
    }

    render() {
        const selected = this.components.find(i => i.name === this.state.selected);
        const SelectedComponent = selected.component;
        return (
            <CheckGitlabAccess>
                <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'row', position: 'relative' }}>
                    <Dialog open={this.state.selecting} onClose={this.hideSelectModal}>
                        <DialogTitle>
                            Select Data to Edit
                        </DialogTitle>
                        <DialogContent>
                            <List component="nav" aria-label="secondary mailbox folders">
                                {
                                    this.components.map(item => (
                                        <ListItem key={item.name} button selected={item.name === this.state.selected} onClick={this.onClick(item.name)}>
                                            <ListItemText primary={item.name + ' - ' + item.file} />
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </DialogContent>
                    </Dialog>
                    <SelectedComponent repo={selected.repo} menu={selected.menu} onSwitch={this.showSelectModal} />
                </div>
            </CheckGitlabAccess>);
    }
}
